import React from 'react';
import { useTranslation } from 'react-i18next';

export default function ContactUs() {
  const { t } = useTranslation();

  return (
    <div className="container">
      <h1>{t('info.contactPage.title')}</h1>
      <p>{t('info.contactPage.description')}</p>
      <address>
        <strong>{t('info.contactPage.emailLabel')}</strong>
        <br />
        <a href="mailto:info.reputelo@gmail.com">info.reputelo@gmail.com</a>
      </address>
      <address>
        <strong>{t('info.contactPage.donateLabel')}</strong>
        <br />
        <a
          href="https://www.patreon.com/reputelo"
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('info.contactPage.donateCta')}
        </a>
      </address>
    </div>
  );
}
